import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
import { ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="py-20 px-6 bg-white" data-id="element-90">
      <div className="max-w-3xl mx-auto text-center" data-id="element-91">
        <FadeIn data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-93">
            Es hora de vivir sin limitaciones
          </h2>
          <p className="text-xl mb-10" data-id="element-94">
            Recupera tu autonomía y vuelve a disfrutar de tus paseos y de tu
            familia. No dejes que el dolor decida qué puedes hacer hoy.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-95">
          <div className="bg-brand-cream border-4 border-brand-gold rounded-3xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-96">
            <div className="absolute top-0 right-0 bg-brand-terracotta text-white px-6 py-2 rounded-bl-2xl font-bold text-sm uppercase tracking-wider" data-id="element-97">
              Oferta Limitada
            </div>

            <h3 className="text-2xl font-bold mb-2 mt-4" data-id="element-98">
              Precio Especial de Lanzamiento
            </h3>
            <div className="text-6xl md:text-7xl font-serif font-bold text-brand-goldDark mb-6" data-id="element-99">
              $6.39{' '}
              <span className="text-2xl text-brand-brown/60 font-sans" data-id="element-100">
                USD
              </span>
            </div>
            <p className="text-lg mb-8 font-medium" data-id="element-101">
              Un solo pago, acceso inmediato a tu correo electrónico.
            </p>

            <CTAButton className="w-full md:w-auto text-2xl py-6 px-10 shadow-xl" data-id="element-102">
              ¡SÍ, QUIERO MI SALUD DORADA AHORA!
            </CTAButton>

            <div className="mt-8 flex flex-col sm:flex-row justify-center items-center gap-6 text-sm font-medium text-brand-brown/70" data-id="element-103">
              <div className="flex items-center" data-id="element-104">
                <ShieldCheckIcon className="w-5 h-5 text-green-600 mr-2" data-id="element-105" />
                Compra segura y protegida
              </div>
              <div className="flex items-center" data-id="element-106">
                <SmartphoneIcon className="w-5 h-5 text-brand-goldDark mr-2" data-id="element-107" />
                Descarga instantánea en tu teléfono o tableta
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}